import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceOrganizationDetailsRoute: InvariantJiraRoute = {
	name: 'customer-service-organization-details',
	path: '/jira/customer-service/organizations/:organizationId',
	exact: true,
};
